import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import Divider from '@material-ui/core/Divider';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import ProductDialog from './ProductDialog'

import ComposedChart from 'recharts/es6/chart/ComposedChart'

import Area from 'recharts/es6/cartesian/Area'
import XAxis from 'recharts/es6/cartesian/XAxis'
import YAxis from 'recharts/es6/cartesian/YAxis'
import Tooltip from 'recharts/es6/component/Tooltip'

import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'

import DiscountIcon from 'mdi-material-ui/Decagram'


const styles = theme => ({
  root:{
    display:"flex",
    justifyContent: "center",

    margin: "auto",

    background: "none",
  },
  card: {
    margin: theme.spacing.unit * 3,
    position: "relative",
    minWidth: 300,
    width: 300,
    height: 350,

    borderRadius: 5,
    //border: "1px solid "+theme.palette.primary.gold
    boxShadow:theme.shadows[7],
    cursor: "pointer",

    "&:hover":{
      boxShadow:"0px 0px 15px 0px rgba(179,135,40,1)",

    },
    overflow: "inherit"
  },

  paper:{

  },
  overlay:{
    position: "absolute",
    top: 0,
    left: 0,

    height: "40%",
    width: "100%",
    background: theme.palette.background.dark,
    clipPath:"polygon(0 0%, 100% 0%, 100% 80%, 90% 82%, 80% 89%, 70% 93%, 60% 92%, 50% 94%, 40% 97%, 30% 95%, 20% 97%, 10% 99%, 0% 98%)",
  },


  //// CONTENT

  title:{
    position: "relative",
    height: "10%",
    color: theme.palette.common.white,
    textTransform:"uppercase",
    textAlign: "center",
    fontSize: 40,
    fontWeight: "700",
  },

  content:{
    position:"relative",
    height: "90%",
    padding: 0,
  },

  priceContainer:{

    height: "30%",
    textAlign: "center",

  },

  price:{

    fontSize: "4rem",
    color: theme.palette.common.white,
    textTransform: "uppercase",
  },
  priceCrossed:{

    fontSize: "4rem",
    color: theme.palette.primary.dark,
    textTransform: "uppercase",


  },
  priceText:{
    fontSize: 20,

    textTransform: "uppercase",
  },


  infoContainer:{
    width: "100%",
    height: "60%",
    position:"relative",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignContent: "center",
    paddingTop: 8,

  },

  info:{
    flexGrow: 6,

    textAlign: "center",
  },

  // BUTTONS
  buttonContainer:{

    position: "absolute",
    top: 0,
    bottom: 0,
    right: theme.spacing.unit * 2,


  },

  /// DISCOUNT ICON
  discountIcon:{
    position:"absolute",
    right: -55,
    top: -45,
    fontSize: 120,
    color: theme.palette.background.dark,
  },

  /// CHART

  barChart:{
    height: "50%",
    width: "100%",



    display: "flex",
    justifyContent: "center",

  }

});

const getAvrageStatistic = (statistic, product)=>{
  let tmp = {
    betsPlayed: 0,
    betsWon: 0,
    budget: 0,
    inputs: 0,
    odds: 0,
    returns: 0,
    values: 0
  }
  let statisticPeriod = product.settings.statisticPeriod ? product.settings.statisticPeriod: 2

  Object
      .keys(statistic.months)
      .filter(key => moment(key, "YYYYMM").isBetween(moment().subtract(statisticPeriod, "months"), moment()) && moment(key, "YYYYMM").year() >= 2020)
      .map(key=> statistic.months[key])
      .forEach(obj=>{
        Object.keys(tmp).forEach((statName)=>{

          if(statName === "budget")tmp.budget = obj.budget
          else{
            tmp[statName] += obj[statName]
          }
        })
      })



  tmp.betsWonAvrage = (100*tmp.betsWon/tmp.betsPlayed).toFixed(2)
  tmp.profit = (tmp.returns-tmp.inputs).toFixed(2)
  tmp.roi = (100*(tmp.returns-tmp.inputs)/tmp.inputs).toFixed(2)
  tmp.betsPlayed = tmp.betsPlayed
  tmp.inputsAvrage = tmp.inputs
  tmp.returnsAvrage = tmp.returns

  return tmp
}

const getGraphData = (statistic)=>{

  return Object.keys(statistic.months).filter((month)=>moment(month, "YYYYMM").month() !== moment().month() && moment(month, "YYYYMM").year() >= 2020).map((month)=>{

    return {month: moment(month, "YYYYMM").unix(), profit: statistic.months[month].budget}
  })
}

const getMonth = (month) =>{
  if(month === 1) return "MESEC"
  if(month === 2) return "MESECA"
  if(month === 3) return "MESECI"
  if(month === 4) return "MESECI"
  if(month > 4) return "MESCEV"
}

class ProductCard extends React.Component {
  state = {
    expanded: false,
    infoOpen: false,
    statistic:( this.props.statistic !=="loading" &&  this.props.statistic)  ? getAvrageStatistic(this.props.statistic, this.props.product) : null,
    graphData:( this.props.statistic !=="loading" &&  this.props.statistic ) ? getGraphData(this.props.statistic ) : []
  }

  static contextTypes = {
    router: PropTypes.object
  }

  renderAreaGraphTooltip = (props)=>{

    const {label, payload} = props

    if(payload){
      return(
        <div style={{textAlign:"center",padding: this.props.theme.spacing.unit * 1,  background:"white", boxShadow: this.props.theme.shadows[5], borderRadius: 10, }}>
          <div>
            <Typography style={{textTransform: "uppercase" }} variant="body1">{moment.unix(label).format("MM-YYYY")}</Typography>

          </div>

          <div style={{display: "flex", flexDirection:"row", flexWrap: "wrap"}}>
            {payload.map((obj, i) =>{
              return(
                <div key={i} style={{padding: this.props.theme.spacing.unit, flexGrow: 6, textAlign: "center"}}>
                  <Typography variant="body1" style={{ textTransform: "uppercase"}} >{obj.name}</Typography>
                  <Typography variant="body1">{obj.value} enot</Typography>
                </div>
              )
            })}
          </div>
        </div>
      )
    }
  }

  simpleBarChart = (data, dataKey) =>{


      if(data.length !== 0){
        return (
          <ResponsiveContainer width="90%" height={"100%"}>
            <ComposedChart margin={{left: 0, bottom: 0, right: 0}}  data={data} >
               <XAxis domain={[data[0].month, data[data.length-1].month]} type="number"  dataKey="month" hide={true}/>
               <YAxis  domain={["auto","auto"]} dataKey="profit" axisLine={false} tickLine={false}  hide={true} mirror={false}/>
               <Tooltip cursor={false} content={this.renderAreaGraphTooltip} />


               <Area isAnimationActive={false}  dataKey={dataKey}  stroke={this.props.theme.palette.primary.dark} fillOpacity="0.4" fill={this.props.theme.palette.primary.gold} />
            </ComposedChart>
          </ResponsiveContainer>
        )
      }

  }

  goToOrders = () => {
    if(this.props.discount) this.context.router.history.push(`/narocilo/${this.props.product.id}?sub=${this.props.product.settings.subscriptionSpanDiscount}`)
    else this.context.router.history.push(`/narocilo/${this.props.product.id}`)
  }

  toggleDialog = ()=>{
    this.setState({infoOpen: !this.state.infoOpen})
  }

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  render() {
    const { classes , product, theme } = this.props;
    const {statistic, graphData}  = this.state
    //<Button style={{position: "absolute", top: -40, right: -40,background: theme.palette.background.gold, height: 100, width: 100, borderRadius: 100, fontSize: 25}} variant="contained">Akcija</Button>
    //console.log(this.props.type)
    return (
      <div className={classes.root}>

        <ProductDialog isActive={this.state.infoOpen} callback={this.toggleDialog} product={product} statistic={statistic} graphData={graphData}/>

        <Card className={classes.card} classes={{root: classes.paper}} onClick={this.props.type === "buy" || this.props.discount ? this.goToOrders : this.toggleDialog} raised>
          <div className={classes.overlay} style={product.settings.discountActive && this.props.discount ? {background: "url(https://i.imgur.com/xl3J7VO.jpg)", backgroundSize: "cover",}:{}}></div>


          {
            this.props.type ==="buy" ? (
                <Button variant="text" color="primary" style={{position: "absolute", bottom: 0, left: 0, fontSize: 18, fontWeight: "bold", borderRadius: 0}} fullWidth>Naroči se</Button>
            ):(
                <Button variant="text" color="primary" style={{position: "absolute", bottom: 0, left: 0, fontSize: 18, fontWeight: "bold", borderRadius: 0}} fullWidth>Naroči paket</Button>
            )
          }

          <div className={classes.title} style={product.settings.discountActive && this.props.discount ? {color: theme.palette.primary.dark}:{}}>
            <Typography style={{paddingTop: theme.spacing.unit * 2, fontWeight:"bold", fontStyle: "italic"}}   variant="title" color="inherit"  >
              {product.name}
            </Typography>
          </div>

          <CardContent classes={{root: classes.content}} >

            <Grid container style={{height: "100%"}}>

              <Grid item xs={12}>

                {
                  product.settings.discountActive && this.props.discount ? (
                    <div  style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems: "center", textAlign:"center"}}>
                      <div>
                        <Typography  variant="title" style={{ paddingTop: theme.spacing.unit * 3, fontSize: 36, fontWeight: "bold"}}>
                          AKCIJSKA CENA
                        </Typography>
                      </div>
                      <div>
                        <Typography style={{ paddingTop: theme.spacing.unit * 6, fontSize: 20, fontWeight: "bold"}}>
                          {Number(product.settings.subscriptionSpanDiscount) * Number(product.settings.subscriptionSpan)}{" "+getMonth(Number(product.settings.subscriptionSpanDiscount) * Number(product.settings.subscriptionSpan))+" ZA"}
                        </Typography>
                        <Typography variant="title" style={{paddingTop: theme.spacing.unit * 2, fontSize: 80, fontWeight: "bold"}}>
                          {(Number(product.amount)*Number(product.settings.subscriptionSpanDiscount)-((Number(product.settings.subscriptionDiscountAmount)/100) * Number(product.amount)*Number(product.settings.subscriptionSpanDiscount))).toFixed(0)}€
                        </Typography>
                      </div>


                    </div>
                  ):(
                    <div className={classes.priceContainer}>
                      <Typography  variant="body1" className={classes.price}>
                        <span style={{textTransform:"lowercase", fontSize: 30}}>od</span> {product.amount}€
                      </Typography>

                    </div>
                  )
                }

                {
                  statistic && !this.props.discount && (
                    <div className={classes.infoContainer}>
                      <div>
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          {statistic.betsPlayed}
                        </Typography>
                        <Divider />
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          <small>ŠT. STAV</small>
                        </Typography>
                      </div>
                      <div>
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          {(statistic.profit/2).toFixed(2)}%
                        </Typography>
                        <Divider />
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          <small>DONOS</small>
                        </Typography>
                      </div>
                      <div>
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          {statistic.profit}e
                        </Typography>
                        <Divider />
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          <small>PROFIT</small>
                        </Typography>
                      </div>
                      <div>
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          {statistic.roi+"%"}
                        </Typography>
                        <Divider />
                        <Typography  variant="body1" color="primary" className={classes.info}>
                          <small>ROI</small>
                        </Typography>
                      </div>
                      <div style={{width:"100%", padding:16, paddingTop: 8, paddingBottom: 0}}>


                      </div>
                      <div className={classes.barChart}>
                        {this.simpleBarChart(graphData, "profit")}

                      </div>
                    </div>
                  )
                }


              </Grid>

            </Grid>

          </CardContent>

        </Card>
      </div>
    );
  }
}

ProductCard.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,

};

export default withStyles(styles, { withTheme: true })(ProductCard);

/*
<div style={{width:"100%", padding:16, paddingTop: 8, paddingBottom: 0}}>
  <Typography style={{fontSize: 10, textAlign:"center"}}>* statistika velja za zadnja 2 meseca</Typography>

</div>
*/



// WEBPACK FOOTER //
// ./src/components/reusableComponents/ProductCard.js